
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import AsyncSelect from 'react-select/async';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import ReportShell, { refreshBtn, excelBtn, thStyle } from './ReportShell';

function CustomerOutstandingReport() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerId, setCustomer] = useState('0');
    const { isAuthenticated, companyId, companyName, branchId, userId, permissions, token, username, logout, branchstate } = useAuth();
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
    }, [isAuthenticated, companyId, token, branchId, logout]);

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    // Customer
    const [CustomerTypeOptions, setCustomerTypeOptions] = useState([]);
    const [selectedCustomerType, setSelectedCustomerType] = useState("");
    const [selectedCustomers, setCustomerType] = useState("0");

    const fetchCustomerType = async () => {
        try {
            const response = await fetchData('ReportApi', `/Customer/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(cmr => ({
                    value: cmr.MasterId,
                    label: cmr.Name
                }));
                setCustomerTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching  Raw Type:', error);
        }
    };

    const handleCustomerTypeChange = (selectedOption) => {
        setSelectedCustomerType(selectedOption);
        setCustomerType(selectedOption.value);
    };

    useEffect(() => {
        fetchCustomerType();
    }, []);

    const fetchTableData = async () => {
        setDataItem([])
        try {
            const response = await fetchData('ReportApi', `/CustomerOutstanding/${companyId}/${selectedCustomers}`, token);
            if (response.responseCode === '1111') {
                setDataItem(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
        }
    };

    const hasReadReportPermission = permissions.includes('Read Reports');
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    // const handleExportExcel = () => {
    //     const excelData = [];
    //     const now = new Date();
    //     const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
    //     // Header Caption
    //     const headerCaption = [`Customer Outstanding From : ${formatDate(fromDate)} To : ${formatDate(toDate)} | Generated On: ${formattedDateTime} By : ${username}`];
    //     excelData.push(headerCaption);
    //     excelData.push([]); // Empty row for spacing

    //     const headerRow = ['Customer', 'Bill Number', 'Bill Date', 'Bill Amount', 'Paid Amount', 'Balance Amount', 'Due Days'];
    //     excelData.push(headerRow);

    //     // Group by CustomerName
    //     let totalSale = 0;
    //     let totalPaid = 0;
    //     let totalBalance = 0;

    //     let previousCustomer = null;

    //     filteredDataItem.forEach((rowData) => {
    //         const {
    //             CustomerName,
    //             BillNumber,
    //             BillDate,
    //             SaleAmount,
    //             PaidAmount,
    //             BalanceAmount,
    //             DueDays
    //         } = rowData;

    //         // Insert Customer Name row when it's new
    //         if (CustomerName !== previousCustomer) {
    //             excelData.push([`${CustomerName}`]);
    //             previousCustomer = CustomerName;
    //         }

    //         // Push bill row
    //         excelData.push([
    //             '', // Name is empty since CustomerName is already printed above
    //             BillNumber,
    //             formatDate(BillDate),
    //             SaleAmount,
    //             PaidAmount,
    //             BalanceAmount,
    //             DueDays
    //         ]);

    //         // Update totals
    //         totalSale += Number(SaleAmount || 0);
    //         totalPaid += Number(PaidAmount || 0);
    //         totalBalance += Number(BalanceAmount || 0);
    //     });

    //     // Empty row before total
    //     excelData.push([]);

    //     // Total row
    //     const totalRow = ['TOTAL', '', '', totalSale.toFixed(2), totalPaid.toFixed(2), totalBalance.toFixed(2), ''];
    //     excelData.push(totalRow);

    //     // Export to Excel
    //     const ws = XLSX.utils.aoa_to_sheet(excelData);
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, 'Customer Outstanding');
    //     XLSX.writeFile(wb, 'Customer_Outstanding_Details.xlsx');
    // };
    const handleExportExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Customer Outstanding");

        //const now = new Date();
        // const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
        const now = new Date();
        const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
        const title = `${companyName} - Customer Outstanding From: ${formatDate(fromDate)} To: ${formatDate(toDate)} | Generated On: ${formattedDateTime} By: ${username}`;    
        // 🟦 Title Row
        worksheet.mergeCells('A1:G1');
        const titleCell = worksheet.getCell('A1');
        titleCell.value = title;
        titleCell.font = { bold: true, size: 10 };
        titleCell.alignment = { vertical: 'middle', horizontal: 'center' };
        titleCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFDDEEFF' }
        };

        // 🟩 Header Row
        const headerRow = worksheet.addRow([
            'Customer',
            'Bill Number',
            'Bill Date',
            'Bill Amount',
            'Paid Amount',
            'Balance Amount',
            'Due Days'
        ]);

        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFCCE5FF' }, // light blue
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        });

        // 🟨 Data Rows
        let totalSale = 0;
        let totalPaid = 0;
        let totalBalance = 0;

        let previousCustomer = null;

        filteredDataItem.forEach((rowData) => {
            const {
                CustomerName,
                BillNumber,
                BillDate,
                SaleAmount,
                PaidAmount,
                BalanceAmount,
                DueDays
            } = rowData;

            // Insert Customer Name row when it's new
            if (CustomerName !== previousCustomer) {
                const custRow = worksheet.addRow([CustomerName]);
                custRow.font = { bold: true };
                previousCustomer = CustomerName;
            }

            // Add bill row
            const row = worksheet.addRow([
                '', // Customer empty since it's printed above
                BillNumber,
                formatDate(BillDate),
                Number(SaleAmount || 0).toFixed(2),
                Number(PaidAmount || 0).toFixed(2),
                Number(BalanceAmount || 0).toFixed(2),
                DueDays
            ]);

            row.eachCell((cell, colNumber) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
                if ([4, 5, 6].includes(colNumber)) {
                    cell.alignment = { horizontal: 'right' };
                } else {
                    cell.alignment = { horizontal: 'left' };
                }
            });

            totalSale += Number(SaleAmount || 0);
            totalPaid += Number(PaidAmount || 0);
            totalBalance += Number(BalanceAmount || 0);
        });

        // Empty row before total
        worksheet.addRow([]);

        // 🟥 Total Row
        const totalRow = worksheet.addRow([
            'TOTAL',
            '',
            '',
            totalSale.toFixed(2),
            totalPaid.toFixed(2),
            totalBalance.toFixed(2),
            ''
        ]);

        totalRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFE699' }, // light yellow
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.alignment = { horizontal: 'right' };
        });

        // 📝 Adjust Column Widths
        worksheet.columns = [
            { key: 'customer', width: 30 },
            { key: 'billNo', width: 15 },
            { key: 'billDate', width: 15 },
            { key: 'billAmt', width: 15 },
            { key: 'paidAmt', width: 15 },
            { key: 'balAmt', width: 15 },
            { key: 'dueDays', width: 12 },
        ];

        // 📁 Export
        const buffer = await workbook.xlsx.writeBuffer();
        const fileName = `Customer_Outstanding_${formatDate(toDate).replace(/\//g, '-')}.xlsx`;
        saveAs(new Blob([buffer]), fileName);
    };

    const cellStyle = {
        borderBottom: '1px solid #ddd',
        color: 'black',
        fontWeight: 'bolder',
        padding: '7px',
        fontSize: '12px',
    };


    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(15); // Rows per page
    // Handle page change
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
    };

    // Function to handle drag start
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('columnIndex', index);
    };

    // Function to handle drag over
    const handleDragOver = (e) => {
        e.preventDefault(); // Allow drop
    };

    // Function to handle drop
    const handleDrop = (e, index) => {
        const draggedIndex = e.dataTransfer.getData('columnIndex');
        if (draggedIndex !== index) {
            const newOrder = [...columnOrder];
            // Swap columns
            [newOrder[draggedIndex], newOrder[index]] = [newOrder[index], newOrder[draggedIndex]];
            setColumnOrder(newOrder);
        }
    };

    // Process and paginate the data
    const processedData = filteredDataItem.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    // Define initial column order
    const [columnOrder, setColumnOrder] = useState([
        'Customer',
        'Bill No',
        'Bill Date',
        'Bill Amount',
        'Paid Amount',
        'Balance Amount',
        'Due Days',

    ]);


    return (
        <ReportShell
            title="CUSTOMER OUTSTANDING"
            recordCount={filteredDataItem.length}
            filters={<>
                <div style={{ minWidth: 200 }}>
                    <Select
                        value={selectedCustomerType}
                        onChange={handleCustomerTypeChange}
                        options={CustomerTypeOptions}
                        placeholder="Select Customer"
                        isSearchable
                        menuPortalTarget={document.body}
                        styles={{
                            control: (b) => ({ ...b, minHeight: 28, height: 28, fontSize: 12 }),
                            valueContainer: (b) => ({ ...b, height: 28, padding: '0 6px' }),
                            indicatorsContainer: (b) => ({ ...b, height: 28 }),
                            menuPortal: (b) => ({ ...b, zIndex: 2000 }),
                        }}
                    />
                </div>
            </>}
            actions={<>
                <button onClick={fetchTableData} style={refreshBtn}>Refresh</button>
                <button onClick={handleExportExcel} style={excelBtn}>Excel</button>
            </>}
        >
            <TableContainer component={Paper}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            {[['Customer','left'],['Bill No','left'],['Bill Date','left'],['Bill Amount','right'],['Paid Amount','right'],['Balance Amount','right'],['Due Days','right']].map(([col, align]) => (
                                <TableCell key={col} style={{ ...thStyle, textAlign: align }}>{col}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {processedData.filter(r => r.CustomerName !== 'Total').map((rowData, index) => (
                            <TableRow key={rowData.Id || index} sx={{
                                backgroundColor: rowData.CustomerName === 'Master' ? 'rgba(45,212,191,0.08)' : index % 2 === 0 ? '#fdfdfd' : '#f7fdfc',
                                '&:hover': { backgroundColor: 'rgba(45,212,191,0.06)' },
                            }}>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px' }}>{rowData.CustomerName}</TableCell>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px' }}>{rowData.BillNumber}</TableCell>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px' }}>{rowData.BillDate ? formatDate(rowData.BillDate) : ''}</TableCell>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{rowData.BillAmount ? parseFloat(rowData.BillAmount).toFixed(2) : '0.00'}</TableCell>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{rowData.PaidAmount ? parseFloat(rowData.PaidAmount).toFixed(2) : '0.00'}</TableCell>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{rowData.BalanceAmount ? parseFloat(rowData.BalanceAmount).toFixed(2) : '0.00'}</TableCell>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{rowData.DueDays}</TableCell>
                            </TableRow>
                        ))}
                        <TableRow sx={{ backgroundColor: '#f0f4f4' }}>
                            <TableCell colSpan={3} sx={{ fontWeight: 700, padding: '5px 8px', fontSize: '12px' }}>Total</TableCell>
                            <TableCell sx={{ fontWeight: 700, textAlign: 'right', padding: '5px 8px', fontSize: '12px' }}>
                                {processedData.filter(r => r.CustomerName !== 'Total').reduce((s, r) => s + (parseFloat(r.BillAmount) || 0), 0).toFixed(2)}
                            </TableCell>
                            <TableCell sx={{ fontWeight: 700, textAlign: 'right', padding: '5px 8px', fontSize: '12px' }}>
                                {processedData.filter(r => r.CustomerName !== 'Total').reduce((s, r) => s + (parseFloat(r.PaidAmount) || 0), 0).toFixed(2)}
                            </TableCell>
                            <TableCell sx={{ fontWeight: 700, textAlign: 'right', padding: '5px 8px', fontSize: '12px' }}>
                                {processedData.filter(r => r.CustomerName !== 'Total').reduce((s, r) => s + (parseFloat(r.BalanceAmount) || 0), 0).toFixed(2)}
                            </TableCell>
                            <TableCell />
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </ReportShell>
    );
}

export default CustomerOutstandingReport;
